import React, { useEffect, useRef, useState } from 'react'
import { useMyContext } from '../../../components/Provider/CommonProvider'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif'
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import Response_Processing from '../../../layout/Others/Response_Processing'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import { slugGenerator } from '../../../components/CommonMethod/CommonMethods'
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect'
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading'
import AdminImageUploadZone from '../../../components/CommonComponents/AdminImageUploadZone'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import useCompressImageConfig from '../../../components/CommonApis/Compressimageapi'
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from '../../../CustomFields/saveCustomFieldsStrict'
import { getItemToken } from '../../../Utils/localStorageUtils'
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";

const AudioCategoryAddUpdate = () => {
    const { compressResolutionFormat } = useCompressImageConfig();
    const { fetchRequest, globalImageUplaodAPI } = useMyContext()
    const { id } = useParams()
    const headers = getItemToken('access_token')
    const { location } = useLocation()
    const navigate = useNavigate()
    const baseURL = process.env.REACT_APP_Baseurl

    const references = `${baseURL}/admin/audio-category/create`;
    const labelApi = `${baseURL}/admin/Label-Management/list-source`
    const storeApi = `${baseURL}/admin/audio-category/store`
    const imageUploadApi = globalImageUplaodAPI()
    const editApi = `${baseURL}/admin/audio-category/edit`
    const updateApi = `${baseURL}/admin/audio-category/update`

    const [formData, setFormData] = useState({ name: "", slug: "", artist_type: "", artist_email: "", description: "", parent_id: "", in_home: 0, in_menu: 0, footer: 0, banner: 0, parent_category: 1 })
    const [formDataError, setFormDataError] = useState({})
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [defaultOption, setDefaultOption] = useState({
        categoryOption: [],
        allCategory: []
    })
    const [coverImageFile, setCoverImageFile] = useState(null);
    const [bannerImageFile, setBannerImageFile] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [customFieldValues, setCustomFieldValues] = useState({})

    const combinedRef = useRef({});
    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }

        if (type === 'text') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    };
    const generateSlug = async (title) => {
        const slug = await slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };
    const handleInputKeyDowntitle = (event) => {
        if (!formData?.slug) {
            if (event.key === "Enter" || event.key === "Tab") {
                generateSlug(formData?.name);
            }
        }
    };
    const handleBlurEdittitle = () => {
        generateSlug(formData?.slug);
    }


    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.name);
        }
    };
    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                reject(new Error('Error loading image'));
            };
        });
    };

    const handleFileChange = async (event) => {
        const { files, name, value, accept } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        if (files?.length > 0) {
            const newFile = files[0];

            if (
                (['image'].includes(name)) &&
                !allowedTypes.includes(files[0]?.type)
            ) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));

                if (name === 'image') setCoverImageFile(null);

                combinedRef.current[name]?.focus();
                return;
            }

            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);
            const isValidSizeEqual = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
            const checkSize = compressResolutionFormat?.audios === 1

            if (name == 'image') {
                setCoverImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                if (!allowedTypes.includes(files[0]?.type)) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Only JPG, JPEG, and PNG files are allowed.",
                    }));
                    combinedRef.current['image'].focus()
                    return;
                }
                if (checkSize && !isValidSizeEqual) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 1:1 Ratio or 1080px (x) 1080px",
                    }));
                    combinedRef.current['image'].focus()
                    return;
                }
            }
            if (name == 'banner_image') {
                setBannerImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    [name]: newFile
                }))
                // Validation for banner size can be added here if needed similar to image
            }
        }
    }
    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        } else if (value == 'banner_image') {
            setBannerImageFile(null)
        }
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))

    }

    const labelFetch = async () => {
        try {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                params: { source: "audio-category" },
                data: {},
            }).then((res) => {
                setLabelDisplay(res?.label_management)
            })
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setLoading(false)
        }
    }
    const formValidation = () => {

        let formIsValid = true;
        if (!formData?.name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Audio Category name cannot be empty.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        } else if (!formData?.slug) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Audio Category Slug cannot be empty.",
            }));
            combinedRef.current['slug'].focus()
            formIsValid = false;
        }
        if (formDataError?.image) {
            combinedRef.current['image'].focus()
            formIsValid = false;
        }
        if (compressResolutionFormat?.audios === 1) {
            if (id && !formData?.image || !id && !coverImageFile) {
                setFormDataError(prev => ({
                    ...prev,
                    image: "Please provide cover image"
                }));
                combinedRef.current['image'].focus();
                formIsValid = false;
            }
        }


        if (!formData?.name || formData?.name.trim().length < 3 || formData?.name.trim().length > 100) {
            toast.error("Name must be between 3 and 100 characters.");
            formIsValid = false;
        }

        // Validate slug
        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            toast.error("Slug must be between 3 and 100 characters.");
            formIsValid = false;
        }

        return formIsValid;
    }
    const handleImageUpload = async (id) => {
        const formDataSubmit = new FormData();
        const imageFields = [];
        formDataSubmit?.append("id", id);
        formDataSubmit?.append("modelName", "AudioCategory");
        if (coverImageFile) {
            formDataSubmit?.append("image", coverImageFile);
            imageFields.push("image");
        }
        if (bannerImageFile) {
            formDataSubmit?.append("banner_image", bannerImageFile);
            imageFields.push("banner_image");
        }
        imageFields.forEach((field) => {
            formDataSubmit.append('imageFields[]', field);
        });
        await fetchRequest({
            method: 'POST',
            url: `${imageUploadApi}`,
            params: {},
            data: formDataSubmit,
        })
            .then(response => {
                if (response?.status) {
                    setCoverImageFile(null)
                    setBannerImageFile(null)
                }
            }).catch((err) => {
                toast.error(err?.response?.data?.message)
            }).finally(() => {

            })
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        if (formValidation()) {
            handleAction()
        }
        else {
            console.table("validation")
        }
    }
    const handleAction = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["name", "slug", "parent_id", "in_home", "in_menu", "banner", "footer"].includes(key)) {
                    formDataAdd[key] = formData[key];
                }
            }
            if (Number(formData?.parent_category) === 1) {
                formDataAdd.parent_id = null;
            }

            const response = await fetchRequest({
                method: `${id ? 'PATCH' : 'POST'}`,
                url: `${id ? `${updateApi}/${id}` : storeApi}`,
                params: {},
                data: formDataAdd,
            });

            if (response?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'audio_category', entityId: id || response?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.response?.data?.message || e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile || bannerImageFile) {
                    await handleImageUpload(id || response?.id);
                }
                toast.success(response?.message);
                if (!id) {
                    navigate("/audio-categories");
                }
                else {
                    setWithOutRefresh(prev => !prev)
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || 'An error occurred.');
        } finally {
            setShowOverlay(false);
        }
    }


    useEffect(async () => {
        if (!id) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${references}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setDefaultOption((prev) => ({
                            ...prev,
                            categoryOption: response?.AllAudioGenre,
                            allCategory: response?.AllAudioGenre
                        }))
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
        else {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setDefaultOption((prev) => ({
                            ...prev,
                            categoryOption: response?.AllAudioGenre,
                            allCategory: response?.All_AudioGenre
                        }))
                        setFormData({
                            ...response?.Audio_Genre,
                            parent_category: response?.Audio_Genre?.parent_id ? 0 : 1
                        })
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }

    }, [withOutRefresh, location]);

    useEffect(() => {
        labelFetch()
    }, [])

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    function flattenCategories(list, level = 0, result = []) {
      if (!list) return result;
      list.forEach(item => {
        const indent = '\u00A0\u00A0\u00A0\u00A0'.repeat(level);
        const prefix = level ? '• ' : '';
  
        result.push({
          id: item.id,
          label: `${indent}${prefix}${item.name}`,
          name: item.name
        });
  
        const subs = item.sub_category || item.sub_categories;
        if (subs?.length) {
          flattenCategories(subs, level + 1, result);
        }
      });
      return result;
    }
  
    const dataToFlatten = defaultOption?.allCategory?.length ? defaultOption.allCategory : (defaultOption?.categoryOption || []);
    const flatOptions = flattenCategories(dataToFlatten);

    return (
        <div>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation text="Back" path="/audio-categories" />
            <AdminSaveHeader loading={showOverlay} heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[8]?.title} saveText={!id ? labelDisplay?.[7]?.title : labelDisplay?.[7]?.sub_title} saveMethod={handleSubmit} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!id ? labelDisplay?.[1]?.title : formData?.name} />
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Audio category Name"} ref={(el) => (combinedRef.current.name = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.name} id="audioCategoryName" />
                        <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="slug" value={formData?.slug} onChange={handleInput} onBlur={handleBlurEdittitle} placeHolder={"Audio category Slug"} ref={(el) => (combinedRef.current.slug = el)} error={formDataError?.slug} id="audioCategorySlug" />
                        <FormContainer>
                            <div className="col-7 col-md-7 pe-2">
                                <MessageLabel text={"Make as Parent Category"} />
                            </div>
                            <div className="col-5 col-md-5 ps-2 text-end">
                                <AdminSwitch id="audio-retain-value" name="parent_category" checked={Number(formData?.parent_category) === 1} onChange={handleInput} />
                            </div>
                        </FormContainer>
                        {Number(formData?.parent_category) === 0 && (
                            <>
                                <MessageLabel text={labelDisplay?.[4]?.title || "Parent Category"} />
                                <select
                                    name="parent_id"
                                    value={formData?.parent_id || ""}
                                    onChange={handleInput}
                                    className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                                >
                                    <option value="">Choose an audio category</option>
                                    {flatOptions.map(opt => (
                                        <option className="theme-bg-color theme-text-color" key={opt.id} value={opt.id}>{opt.label}</option>
                                    ))}
                                </select>
                                {formDataError?.parent_id && (
                                    <p className="text-danger">{formDataError.parent_id}</p>
                                )}
                            </>
                        )}

                        <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields */}
                            <FieldRenderer2
                                pageIdentifier={id ? "audio_category.edit" : "audio_category.create"}
                                entityType="audio_category"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "audio_category.edit" : "audio_category.create"}
                                entityType="audio_category"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>

                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[5]?.title} />
                        <MessageLabel text={labelDisplay?.[6]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />

                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.image_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            id={id}
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.image}
                            idAttribute="audioCategoryImageUpload"
                        />
                        
                        <MessageHeading text={"Banner Image"} />
                        <MessageLabel text={"Upload Banner Image"} className="" />
                        <MessageSubHeading text={"Select the image ( 16:9 Ratio )"} />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={bannerImageFile}
                            uploadedImage={formData?.banner_image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.banner_image = el)}
                            name="banner_image"
                            id={`banner-${id}`}
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.banner_image}
                            idAttribute="audioCategoryBannerUpload"
                        />
                    </Wrapper>
                    <Wrapper>
                        <MessageHeading text={"Category Settings"} />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"In Home"} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="audio-category-in-home" name={"in_home"} checked={Number(formData?.in_home) === 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"In Menu"} className="" />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch id="audio-category-in-menu" name={"in_menu"} checked={Number(formData?.in_menu) === 1} onChange={handleInput} />
                            </div>
                        </div>
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' loading={showOverlay} saveMethod={handleSubmit} saveText={!id ? labelDisplay?.[7]?.title : labelDisplay?.[7]?.sub_title} />
            </FormContainer>
        </div>
    )
}

export default AudioCategoryAddUpdate